/**
 * Truncates the middle part of a string with ellipsis
 * @param string The string to truncate
 * @param startLength The number of characters to show at the start of the string before ellipsis
 * @param endLength The number of characters to show at the end of the string after ellipsis
 * @returns truncated string
 */

export function truncateMiddle(str: string, startLength = 5, endLength = 5) {
  const start = str.substring(0, startLength);
  const end = str.substring(str.length - endLength);

  return start + "..." + end;
}
